import React from 'react';
import { CHECKOUT_URL } from '../../data/content';
import { CtaButton } from '../ui/CtaButton';
import { SectionLabel } from '../ui/SectionLabel';
export function FinalCta() {
  return <section aria-labelledby="cta-final-title" className="w-full bg-gradient-to-b from-ink-900 to-pitch" data-id="element-83" data-mp="1np9cul1hkh86">
      <div className="mx-auto flex max-w-3xl flex-col items-center px-5 py-20 text-center" data-id="element-84" data-mp="1sn15jh9yg7df">
        <SectionLabel tone="gold" data-id="element-85" data-mp="1eo1rt4nzdcw1">Oferta especial de lanzamiento</SectionLabel>
        <h2 id="cta-final-title" className="mt-6 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-86" data-mp="1ipn34lkv9j44">
          Empieza a proteger la carrera de tu hijo hoy
        </h2>
        <p className="mt-4 max-w-xl text-base leading-relaxed text-body" data-id="element-87" data-mp="19of4u3icoia1">
          MÉTODO PARA PADRES DE FUTBOLISTAS — 5 módulos + 2 bonos. Más claridad,
          menos riesgo y más control de tu familia sobre el proceso.
        </p>
        <p className="mt-8 text-lg font-semibold text-subtle line-through" data-id="element-88" data-mp="342gdth7m6lnu">US$ 87</p>
        <p className="mt-1 font-display text-6xl font-black text-brand-gold md:text-7xl" data-id="element-89" data-mp="27tqpuwhonvs">US$ 15</p>
        <p className="mt-4 max-w-xl text-xs leading-relaxed text-subtle" data-id="element-90" data-mp="3temth36xkv2f">
          Precio en dólares estadounidenses. Al finalizar tu compra, siempre pagarás en tu moneda
          local.
        </p>
        <div className="mt-9" data-id="element-91" data-mp="714tnky6kkif">
          <CtaButton size="xl" href={CHECKOUT_URL} data-id="element-92" data-mp="727fvfkk5ys0">
            Descarga el método — US$ 15
          </CtaButton>
        </div>
        <p className="mt-5 text-sm text-subtle" data-id="element-93" data-mp="3agtrq481mr6m">
          🔒 Pago seguro · ⚡ Acceso inmediato · ✅ Garantía de 7 días
        </p>
        <p className="mt-3 max-w-xl text-xs leading-relaxed text-subtle" data-id="element-94" data-mp="3oh4h12tpfxpo">
          Este material es educativo y no reemplaza la asesoría de un abogado especializado en
          derecho deportivo.
        </p>
      </div>
    </section>;
}